import useHook from './hooks'
import TableAntd from '../../components/TableAntd'
import styles from './style.module.scss'
import { Col, Row, Space, Tabs } from 'antd'
import { paymentStatusKey } from '../../tools/state'
import { ReactComponent as SoundIcon } from '../../assets/img/svg/sound.svg'
import { orderDetailLinkRender } from '../orderassurance/Lander'
import { financialDetailLinkRender } from '../financialreconciliation'
import { supplierPayTypeEnum } from '@/global/enum/invoice'
import moment from 'moment'

const PaymentRequestDetail = () => {
  const { detailInfo, erpTotalPrice } = useHook()
  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const formConfig: {
    [x: string]: {
      listColumn: any[]
      data?: any[]
    }
  } = {
    订单明细: {
      listColumn: [
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          width: 100,
          render: orderDetailLinkRender,
        },
        {
          key: 'customer',
          dataIndex: 'customer',
          title: '客户名称',
          width: 100,
        },
        {
          key: 'platform',
          dataIndex: 'platform',
          title: '下单平台',
          width: 100,
        },
        {
          key: 'paymentDate',
          title: '下单时间',
          width: 100,
          render: (text: any) => {
            return text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-'
          },
        },
        {
          key: 'orderPrice',
          dataIndex: 'orderPrice',
          title: '下单金额',
          width: 100,
        },
        {
          key: 'finalPrice',
          dataIndex: 'finalPrice',
          title: '最终结算金额',
          width: 100,
        },
        {
          key: 'orderState',
          dataIndex: 'orderState',
          title: '订单状态',
          width: 100,
        },
        {
          key: 'customerPayback',
          dataIndex: 'customerPayback',
          title: '对账完毕',
          width: 100,
        },
        {
          key: 'paymentMethodValue',
          dataIndex: 'paymentMethodValue',
          title: '回款方式',
          width: 100,
        },
        {
          key: 'orderInvoiceStatus',
          dataIndex: 'orderInvoiceStatus',
          title: '供应商开票',
          width: 100,
          render: (text: any, record: any) => {
            return financialDetailLinkRender('已开票>', {
              ...record,
              id: record.orderAccountId,
            })
          },
        },
      ],
      data: detailInfo?.orderInfoList,
    },
    物料明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
          width: 50,
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '商品编码',
          width: 100,
        },
        {
          key: 'brandName',
          dataIndex: 'brandName',
          title: '品牌',
          width: 100,
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
          width: 100,
        },
        {
          key: 'model',
          dataIndex: 'model',
          title: '型号',
          width: 100,
        },
        {
          key: 'productCount',
          dataIndex: 'productCount',
          title: '数量',
          width: 100,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 100,
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
          width: 100,
        },
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          width: 100,
        },
      ],
      data: detailInfo?.productInfoList,
    },
  }
  type formConfigKey = keyof typeof formConfig

  const paymentInfoColumn = [
    {
      key: 'time',
      dataIndex: 'time',
      title: '付款日期',
      width: 100,
      render: (text: any) => text || '-',
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '汇款金额',
      width: 100,
    },
  ]
  return (
    <div className={styles['inner-content']}>
      <div className={styles['order-info']}>
        <div className={styles['header']}>
          <Space>
            <span>单据信息</span>
            {detailInfo?.paymentStatus === '付款中' ? (
              <Space size={'small'} align="center">
                <SoundIcon
                  style={{
                    width: '14px',
                    height: '14px',
                    color: 'gold',
                  }}
                />
                <span className={styles['orange-tip']}>等待咸亨付款</span>
              </Space>
            ) : detailInfo?.paymentStatus === '审核中' ? (
              <Space size={'small'} align="center">
                <SoundIcon
                  style={{
                    width: '14px',
                    height: '14px',
                    color: 'gold',
                  }}
                />
                <span className={styles['orange-tip']}>等待咸亨审核</span>
              </Space>
            ) : detailInfo?.paymentStatus === '驳回' ? (
              <Space size={'small'} align="center">
                <SoundIcon
                  style={{
                    width: '14px',
                    height: '14px',
                    color: 'red',
                  }}
                />
                <span className={styles['orange-tip']}>
                  付款申请驳回，{detailInfo?.reason}
                </span>
              </Space>
            ) : null}
          </Space>
        </div>
        <div className={styles['content']}>
          <Row>
            <Col span={6}>
              <span>付款单号：</span>
              <span>{detailInfo?.paymentNo}</span>
            </Col>
            <Col span={6}>
              <span>提交时间：</span>
              <span>{detailInfo?.createTime}</span>
            </Col>
            <Col span={6}>
              <span>提交人：</span>
              <span>{detailInfo?.submitMan}</span>
            </Col>
            <Col span={6}>
              <span>付款方式：</span>
              <span>
                {supplierPayTypeEnum.getLabelByValue(
                  detailInfo?.payType as any,
                )}
                {detailInfo?.payType === 'Z' && `,${detailInfo.payOtherDesc}`}
              </span>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <span>付款单状态：</span>
              <span
                className={
                  styles[
                    detailInfo?.paymentStatus === '审核中' ||
                    detailInfo?.paymentStatus === '付款中'
                      ? 'orange-tip'
                      : detailInfo?.paymentStatus === '驳回' ||
                          detailInfo?.paymentStatus === '已放弃'
                        ? 'red-tip'
                        : ''
                  ]
                }
              >
                {detailInfo?.paymentStatus}
              </span>
            </Col>
            <Col span={6}>
              <span>申请付款金额：</span>
              <span>{detailInfo?.applyPrice}</span>
            </Col>
            <Col span={6}>
              <span>供应商备注：</span>
              <span>{detailInfo?.remark}</span>
            </Col>
          </Row>
        </div>
      </div>
      <div className={styles['tab-container']}>
        <Tabs
          style={{
            width: '100%',
          }}
        >
          {(['订单明细', '物料明细'] as formConfigKey[]).map((item) => {
            return (
              <Tabs.TabPane tab={item} key={item}>
                <TableAntd
                  dataSource={formConfig[item].data ?? []}
                  loading={false}
                  listColumn={formConfig[item].listColumn}
                  rowKey={item === '物料明细' ? 'productId' : 'orderId'}
                  scrollCustom={{ y: 400 }}
                  scrollStyle={{
                    height: 'auto',
                  }}
                ></TableAntd>
              </Tabs.TabPane>
            )
          })}
        </Tabs>
      </div>
      <div className={styles['ticket-info']}>
        <div className={styles['header']}>
          <Row
            justify="space-between"
            style={{
              width: '100%',
            }}
          >
            <Space>
              <span>回款金额</span>
            </Space>
            <div>
              <span>已付金额：</span>
              <span>{erpTotalPrice}</span>
            </div>
          </Row>
        </div>
        <div className={styles['content']}>
          {(detailInfo?.paymentStatus as paymentStatusKey) === '付款完成' ? (
            <TableAntd
              dataSource={detailInfo?.paymentList ?? []}
              loading={false}
              listColumn={paymentInfoColumn}
              rowKey={'accountInvoiceId'}
              scrollCustom={{ y: 400 }}
              scrollStyle={{
                height: 'auto',
              }}
            ></TableAntd>
          ) : (
            <div className={styles['gray-info']}>等待咸亨付款</div>
          )}
        </div>
      </div>
    </div>
  )
}
export default PaymentRequestDetail
import useHook from './hooks'
import TableAntd from '../../components/TableAntd'
import styles from './style.module.scss'
import { Col, Row, Space, Tabs } from 'antd'
import { paymentStatusKey } from '../../tools/state'
import { ReactComponent as SoundIcon } from '../../assets/img/svg/sound.svg'
import { orderDetailLinkRender } from '../orderassurance/Lander'
import { financialDetailLinkRender } from '../financialreconciliation'
import { supplierPayTypeEnum } from '@/global/enum/invoice'
import moment from 'moment'

const PaymentRequestDetail = () => {
  const { detailInfo, erpTotalPrice } = useHook()
  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const formConfig: {
    [x: string]: {
      listColumn: any[]
      data?: any[]
    }
  } = {
    订单明细: {
      listColumn: [
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          width: 100,
          render: orderDetailLinkRender,
        },
        {
          key: 'customer',
          dataIndex: 'customer',
          title: '客户名称',
          width: 100,
        },
        {
          key: 'platform',
          dataIndex: 'platform',
          title: '下单平台',
          width: 100,
        },
        {
          key: 'paymentDate',
          title: '下单时间',
          width: 100,
          render: (text: any) => {
            return text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-'
          },
        },
        {
          key: 'orderPrice',
          dataIndex: 'orderPrice',
          title: '下单金额',
          width: 100,
        },
        {
          key: 'finalPrice',
          dataIndex: 'finalPrice',
          title: '最终结算金额',
          width: 100,
        },
        {
          key: 'orderState',
          dataIndex: 'orderState',
          title: '订单状态',
          width: 100,
        },
        {
          key: 'customerPayback',
          dataIndex: 'customerPayback',
          title: '对账完毕',
          width: 100,
        },
        {
          key: 'paymentMethodValue',
          dataIndex: 'paymentMethodValue',
          title: '回款方式',
          width: 100,
        },
        {
          key: 'orderInvoiceStatus',
          dataIndex: 'orderInvoiceStatus',
          title: '供应商开票',
          width: 100,
          render: (text: any, record: any) => {
            return financialDetailLinkRender('已开票>', {
              ...record,
              id: record.orderAccountId,
            })
          },
        },
      ],
      data: detailInfo?.orderInfoList,
    },
    物料明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
          width: 50,
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '商品编码',
          width: 100,
        },
        {
          key: 'brandName',
          dataIndex: 'brandName',
          title: '品牌',
          width: 100,
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
          width: 100,
        },
        {
          key: 'model',
          dataIndex: 'model',
          title: '型号',
          width: 100,
        },
        {
          key: 'productCount',
          dataIndex: 'productCount',
          title: '数量',
          width: 100,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 100,
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
          width: 100,
        },
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          width: 100,
        },
      ],
      data: detailInfo?.productInfoList,
    },
  }
  type formConfigKey = keyof typeof formConfig

  const paymentInfoColumn = [
    {
      key: 'time',
      dataIndex: 'time',
      title: '付款日期',
      width: 100,
      render: (text: any) => text || '-',
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '汇款金额',
      width: 100,
    },
  ]
  return (
    <div className={styles['inner-content']}>
      <div className={styles['order-info']}>
        <div className={styles['header']}>
          <Space>
            <span>单据信息</span>
            {detailInfo?.paymentStatus === '付款中' ? (
              <Space size={'small'} align="center">
                <SoundIcon
                  style={{
                    width: '14px',
                    height: '14px',
                    color: 'gold',
                  }}
                />
                <span className={styles['orange-tip']}>等待咸亨付款</span>
              </Space>
            ) : detailInfo?.paymentStatus === '审核中' ? (
              <Space size={'small'} align="center">
                <SoundIcon
                  style={{
                    width: '14px',
                    height: '14px',
                    color: 'gold',
                  }}
                />
                <span className={styles['orange-tip']}>等待咸亨审核</span>
              </Space>
            ) : detailInfo?.paymentStatus === '驳回' ? (
              <Space size={'small'} align="center">
                <SoundIcon
                  style={{
                    width: '14px',
                    height: '14px',
                    color: 'red',
                  }}
                />
                <span className={styles['orange-tip']}>
                  付款申请驳回，{detailInfo?.reason}
                </span>
              </Space>
            ) : null}
          </Space>
        </div>
        <div className={styles['content']}>
          <Row>
            <Col span={6}>
              <span>付款单号：</span>
              <span>{detailInfo?.paymentNo}</span>
            </Col>
            <Col span={6}>
              <span>提交时间：</span>
              <span>{detailInfo?.createTime}</span>
            </Col>
            <Col span={6}>
              <span>提交人：</span>
              <span>{detailInfo?.submitMan}</span>
            </Col>
            <Col span={6}>
              <span>付款方式：</span>
              <span>
                {supplierPayTypeEnum.getLabelByValue(
                  detailInfo?.payType as any,
                )}
                {detailInfo?.payType === 'Z' && `,${detailInfo.payOtherDesc}`}
              </span>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <span>付款单状态：</span>
              <span
                className={
                  styles[
                    detailInfo?.paymentStatus === '审核中' ||
                    detailInfo?.paymentStatus === '付款中'
                      ? 'orange-tip'
                      : detailInfo?.paymentStatus === '驳回' ||
                          detailInfo?.paymentStatus === '已放弃'
                        ? 'red-tip'
                        : ''
                  ]
                }
              >
                {detailInfo?.paymentStatus}
              </span>
            </Col>
            <Col span={6}>
              <span>申请付款金额：</span>
              <span>{detailInfo?.applyPrice}</span>
            </Col>
            <Col span={6}>
              <span>供应商备注：</span>
              <span>{detailInfo?.remark}</span>
            </Col>
          </Row>
        </div>
      </div>
      <div className={styles['tab-container']}>
        <Tabs
          style={{
            width: '100%',
          }}
        >
          {(['订单明细', '物料明细'] as formConfigKey[]).map((item) => {
            return (
              <Tabs.TabPane tab={item} key={item}>
                <TableAntd
                  dataSource={formConfig[item].data ?? []}
                  loading={false}
                  listColumn={formConfig[item].listColumn}
                  rowKey={item === '物料明细' ? 'productId' : 'orderId'}
                  scrollCustom={{ y: 400 }}
                  scrollStyle={{
                    height: 'auto',
                  }}
                ></TableAntd>
              </Tabs.TabPane>
            )
          })}
        </Tabs>
      </div>
      <div className={styles['ticket-info']}>
        <div className={styles['header']}>
          <Row
            justify="space-between"
            style={{
              width: '100%',
            }}
          >
            <Space>
              <span>回款金额</span>
            </Space>
            <div>
              <span>已付金额：</span>
              <span>{erpTotalPrice}</span>
            </div>
          </Row>
        </div>
        <div className={styles['content']}>
          {(detailInfo?.paymentStatus as paymentStatusKey) === '付款完成' ? (
            <TableAntd
              dataSource={detailInfo?.paymentList ?? []}
              loading={false}
              listColumn={paymentInfoColumn}
              rowKey={'accountInvoiceId'}
              scrollCustom={{ y: 400 }}
              scrollStyle={{
                height: 'auto',
              }}
            ></TableAntd>
          ) : (
            <div className={styles['gray-info']}>等待咸亨付款</div>
          )}
        </div>
      </div>
    </div>
  )
}
export default PaymentRequestDetail
